import React, { Component } from 'react';
import PropTypes, { checkPropTypes } from 'prop-types';
import { Cell } from 'fixed-data-table-2';
import { FormGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { toJS } from '../../../../../containers/to-js';
import { pushTid, popTid } from '../../../../../actions/workflow-actions'; 

class RowSelectorCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            tid: null
        }
    }
    componentWillReceiveProps(nextProps) {
        const { rows, columnKey, rowIndex, selectAll, readOnlyTableWithSelection, changeVal, classProperty, 
            formValues, hasModifiedClassProperty, getNewContext, setTotalSelected } = nextProps;
        const row = rows.getObjectAt(rowIndex);
        if(readOnlyTableWithSelection)
        {
            let val = hasModifiedClassProperty ? getNewContext(formValues, classProperty) : formValues ? formValues[classProperty] : [];
            val = val ? val : []
            if(selectAll === true){
                const f = val.find(v=> v.id == row.id)
                if(!f){
                    const newRow = {
                        class: row.class,
                        id: row.id
                    }
                    val.push(newRow)
                }
                this.setState({checked: true, tid: row.id})
                changeVal(classProperty, val);
                setTotalSelected(val)
                
            } else if(selectAll === false) {
                val.map((v,i) => {
                    if(v.id == row.id)
                        val.splice(i, 1);
                });
                this.setState({checked: false, tid: null})
                changeVal(classProperty, val)
                setTotalSelected(val)
            } else {
                val.map((v,i) => {
                    if(v.id == row.id)
                        this.setState({tid: row.id, checked: true});
                });
            }
            // this.setState({tid: null})
        }
    }
    onChange(tid,row, ev) {
        const checked = ev.target.checked;
        const { pushTid, popTid, readOnlyTableWithSelection, changeVal, classProperty, 
            formValues, hasModifiedClassProperty, getNewContext, selectAllNotClicked, setTotalSelected } = this.props;
            console.log(tid, checked, readOnlyTableWithSelection)
        if(readOnlyTableWithSelection)
        {
            let val = hasModifiedClassProperty ? getNewContext(formValues, classProperty) : formValues ? formValues[classProperty] : [];
            val = val ? val : []
            this.setState({checked: checked, tid: tid}, () => {
                if(checked){
                const newRow = {
                    class: row.class,
                    id: row.id
                }
                val.push(newRow)
                changeVal(classProperty, val);
                setTotalSelected(val)
                
                } else {
                    let index = -1;
                    val.map((v,i) => {
                        if(v.id == row.id)
                            val.splice(i, 1);
                    });
                    
                    changeVal(classProperty, val)
                    setTotalSelected(val)
                }
            })
            
        } else {
            checked ? pushTid(tid) : popTid(tid);
        }
    }
    render() {
        const { rows, columnKey, rowIndex } = this.props;
        if (!rows || !rows.getSize()) return null;
        const tid = rows.getObjectAt(rowIndex)[columnKey];
        const row = rows.getObjectAt(rowIndex);
        let checked = false;
        if(this.props.selectAll && this.state.checked) {
            checked = this.props.selectAll;
        } else if((this.props.selectAll || !this.props.selectAll) && this.state.checked != null && this.state.tid == tid) {
            checked = this.state.checked
        } else {
            checked = this.props.selectAll
        }
        console.log(tid, checked);
        // console.log(this.props.selectAll || !this.props.selectAll)
        //  this.props.selectAll && this.state.checked == null ? this.props.selectAll : 
        //     (this.props.selectAll || !this.props.selectAll) && this.state.checked != null && this.state.tid == tid
        //      ?  this.state.checked : this.props.selectAll;
        
        // console.log(checked, this.state.tid == tid);
        return (
            <Label check className='w-100 h-100 d-flex justify-content-center align-items-center'>
                <Input onChange={this.onChange.bind(this, tid, row)} 
                    style={{ position: 'relative', width: 35, height: 35, marginLeft: -7, marginTop: 0 }} 
                    type="checkbox" checked={checked}/>
            </Label>
        );
    }
}

RowSelectorCell.defaultProps = {
    rows: []
}

RowSelectorCell.propTypes = {
    rows: PropTypes.array,
    columnKey: PropTypes.string,
    rowIndex: PropTypes.number
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        pushTid: (tid) => {
            dispatch(pushTid(tid));
        },
        popTid: (tid) => {
            dispatch(popTid(tid));
        }
    }
};

export default connect(null, mapDispatchToProps)(toJS(RowSelectorCell));